// Sent emails from us to all users
export const EMAILS_SENT_EMAILS_REQUEST = '[EMAILS]_SENT_EMAILS_REQUEST';
export const EMAILS_SENT_EMAILS_RESPONSE = '[EMAILS]_SENT_EMAILS_RESPONSE';
export const EMAILS_SENT_EMAILS_FAILURE = '[EMAILS]_SENT_EMAILS_FAILURE';

export const EMAILS_RECEIVED_EMAILS_REQUEST = '[EMAILS]_RECEIVED_EMAILS_REQUEST';
export const EMAILS_RECEIVED_EMAILS_RESPONSE = '[EMAILS]_RECEIVED_EMAILS_RESPONSE';
export const EMAILS_RECEIVED_EMAILS_FAILURE = '[EMAILS]_RECEIVED_EMAILS_FAILURE';
